import { render } from "./ChartCriteriaMixins.vue?vue&type=template&id=2b0f8932"
import script from "./ChartCriteriaMixins.vue?vue&type=script&lang=js"
export * from "./ChartCriteriaMixins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__